module.exports = __webpack_public_path__ + "img/drh5_language_tc.7064d783.png";